"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "propType", {
  enumerable: true,
  get: function get() {
    return _contextStore.propType;
  }
});
exports.default = void 0;
var _contextStore = _interopRequireWildcard(require("./context-store"));
var _default = _contextStore.default;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVDb250ZXh0U3RvcmUiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udGV4dC9jb250ZXh0LXN0b3JlL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBjcmVhdGVDb250ZXh0U3RvcmUsIHsgcHJvcFR5cGUgfSBmcm9tICcuL2NvbnRleHQtc3RvcmUnO1xuXG5leHBvcnQgZGVmYXVsdCBjcmVhdGVDb250ZXh0U3RvcmU7XG5leHBvcnQgeyBwcm9wVHlwZSB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7QUFBK0QsZUFFaERBLHFCQUFrQjtBQUFBIn0=